import React, { Component } from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';

class Select extends Component {
  state = {};
  render() {
    return (
      <Root>
        <SelectBox {...this.props} />
      </Root>
    );
  }
}

const Root = styled.div`
  display: block;
  position: relative;
  width: 100%;
  @media (max-width: ${media.xs}) {
    max-width: 100%;
  }
  &::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 8px;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    background-image: url('/assets/images/icons/chevron.svg');
    background-size: cover;
  }
`;

const SelectBox = styled.select`
  padding: 14px;
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #fff;
  color: #fff;
  font-family: 'DINOT';
  font-size: 18px;
  width: 100%;
  border-radius: 0;
  display: block;
  -webkit-appearance: none;
  outline: none;
  transition: all 0.25s max-width 0;
  box-shadow: 0 0 5px 0 transparent;
  option {
    color: #051C2C;
  }
  &:focus {
    box-shadow: 0 0 5px 0 #f58320;
    border: 1px solid #f58320;
  }
`;

export default Select;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/elements/Select.js